import * as LucideIcons from 'lucide-react'
import type { LucideProps } from 'lucide-react'

interface WorkItemTypeIconProps extends Omit<LucideProps, 'color'> {
  icon: string
  color: string
}

/**
 * Renders a Lucide icon by name, coloured with the work item type colour.
 * Falls back to a generic square if the icon name is not found.
 */
export function WorkItemTypeIcon({ icon, color, className, ...props }: WorkItemTypeIconProps) {
  const Icon = (LucideIcons as any)[icon] as React.FC<LucideProps> | undefined
  const Fallback = LucideIcons.Square

  const Component = Icon ?? Fallback

  return (
    <Component
      className={className ?? 'size-4 shrink-0'}
      style={{ color }}
      {...props}
    />
  )
}
